var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "72",
        height: "72",
        viewBox: "0 0 72 72",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M36 15.6923C24.7844 15.6923 15.6923 24.7844 15.6923 36C15.6923 47.2156 24.7844 56.3077 36 56.3077C47.2156 56.3077 56.3077 47.2156 56.3077 36C56.3077 24.7844 47.2156 15.6923 36 15.6923ZM12 36C12 22.7452 22.7452 12 36 12C49.2548 12 60 22.7452 60 36C60 49.2548 49.2548 60 36 60C22.7452 60 12 49.2548 12 36Z",
          fill: "#DD3537"
        }
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M36.0005 23.0762C37.19 23.0762 38.1543 24.161 38.1543 25.4992L38.1543 40.0377C38.1543 41.3759 37.19 42.4608 36.0004 42.4608C34.8109 42.4608 33.8466 41.3759 33.8466 40.0377L33.8466 25.4992C33.8466 24.161 34.8109 23.0762 36.0005 23.0762Z",
          fill: "#DD3537"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M38.1534 46.7691C38.1534 47.9586 37.1891 48.9229 35.9995 48.9229C34.81 48.9229 33.8457 47.9586 33.8457 46.7691C33.8457 45.5795 34.81 44.6152 35.9995 44.6152C37.1891 44.6152 38.1534 45.5795 38.1534 46.7691Z",
          fill: "#DD3537"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }